"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DateRange_1 = require("../../core/model/date-time/DateRange");

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");

var PromotionWeekType_1 = require("../../promotion/enums/PromotionWeekType");

var PromotionSelectEnum_1 = require("../../promotion/model/PromotionSelectEnum");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowSearchFilter_1 = require("./WindowSearchFilter");

var WindowSelectEnum_1 = require("./WindowSelectEnum");

var WindowStateEnum_1 = require("./WindowStateEnum");

var WindowFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(WindowFilter, _AbstractEntityFilter);

  /**
   * @param ids
   * @param themeId
   * @param promotionId
   * @param simulationId
   * @param limit
   * @param offset
   * @param windowTypeIds
   * @param promotionTypeIds
   * @param years
   * @param weeks
   * @param select
   * @param filter - accepts string that is searched in external id and name ( via regexp )
   * @param promotionIds
   * @param promotionWeekType
   * @param themeIds
   * @param states
   * @param excludedStates
   * @param simulationsOnly Only simulated windows will be returned when true, not simulated when false, all when null
   * @param stateFlags
   * @param portfolios
   * @param dummy
   * @param dummyOriginId
   * @param storeSpecifications
   * @param promotionWFState
   * @param windowWFState
   * @param fcApprovalRequired relates to {@link Window#forecastCoordinatorFlag}
   * @param validityInterval - a date range the window validity has to intersect with
   */
  function WindowFilter(limit, offset, ids, themeId, promotionId, simulationId, windowTypeIds, promotionTypeIds, years, weeks, select, filter, promotionIds, promotionWeekType, themeIds, states, excludedStates) {
    var _this;

    var simulationsOnly = arguments.length > 17 && arguments[17] !== undefined ? arguments[17] : false;
    var stateFlags = arguments.length > 18 ? arguments[18] : undefined;
    var portfolios = arguments.length > 19 ? arguments[19] : undefined;
    var dummy = arguments.length > 20 ? arguments[20] : undefined;
    var dummyOriginId = arguments.length > 21 ? arguments[21] : undefined;
    var storeSpecifications = arguments.length > 22 ? arguments[22] : undefined;
    var promotionWFState = arguments.length > 23 ? arguments[23] : undefined;
    var windowWFState = arguments.length > 24 ? arguments[24] : undefined;
    var fcApprovalRequired = arguments.length > 25 ? arguments[25] : undefined;
    var validityInterval = arguments.length > 26 ? arguments[26] : undefined;

    _classCallCheck(this, WindowFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowFilter).call(this, limit, offset));
    _this.limit = limit;
    _this.offset = offset;
    _this.ids = ids;
    _this.themeId = themeId;
    _this.promotionId = promotionId;
    _this.simulationId = simulationId;
    _this.windowTypeIds = windowTypeIds;
    _this.promotionTypeIds = promotionTypeIds;
    _this.years = years;
    _this.weeks = weeks;
    _this.select = select;
    _this.filter = filter;
    _this.promotionIds = promotionIds;
    _this.promotionWeekType = promotionWeekType;
    _this.themeIds = themeIds;
    _this.states = states;
    _this.excludedStates = excludedStates;
    _this.simulationsOnly = simulationsOnly;
    _this.stateFlags = stateFlags;
    _this.portfolios = portfolios;
    _this.dummy = dummy;
    _this.dummyOriginId = dummyOriginId;
    _this.storeSpecifications = storeSpecifications;
    _this.promotionWFState = promotionWFState;
    _this.windowWFState = windowWFState;
    _this.fcApprovalRequired = fcApprovalRequired;
    _this.validityInterval = validityInterval;
    return _this;
  } // select is type of WindowSelectEnum but WindowSearchFilter requires PromotionSelectEnum...


  _createClass(WindowFilter, [{
    key: "toWindowSearchFilter",
    value: function toWindowSearchFilter() {
      return new WindowSearchFilter_1.WindowSearchFilter(this.years ? immutable_1.List(this.years) : undefined, this.weeks ? immutable_1.List(this.weeks) : undefined, this.filter, this.portfolios, this.promotionWeekType, this.select === WindowSelectEnum_1.WindowSelectEnum.Open ? PromotionSelectEnum_1.PromotionSelectEnum.Open : PromotionSelectEnum_1.PromotionSelectEnum.Valid, this.storeSpecifications, this.states, this.windowTypeIds, this.themeIds);
    }
  }]);

  return WindowFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.WindowFilter = WindowFilter;
WindowFilter.EMPTY = new WindowFilter();

WindowFilter.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowFilter.name);
  return {
    limit: builder.opt(builder.num('limit')),
    offset: builder.opt(builder.num('offset')),
    ids: builder.opt(builder.listOf(builder.str('ids'))),
    themeId: builder.opt(builder.str('themeId')),
    promotionId: builder.opt(builder.str('promotionId')),
    simulationId: builder.opt(builder.str('simulationId')),
    windowTypeIds: builder.opt(builder.listOf(builder.str('windowTypeIds'))),
    promotionTypeIds: builder.opt(builder.listOf(builder.str('promotionTypeIds'))),
    years: builder.opt(builder.arr(builder.num('years'))),
    weeks: builder.opt(builder.arr(builder.num('weeks'))),
    select: builder.opt(new PropDesc_1.PropDesc(new Parser_1.EnumParser(WindowSelectEnum_1.WindowSelectEnum), {
      nameKey: 'select',
      lookup: ''
    })),
    filter: builder.opt(builder.str('filter')),
    promotionIds: builder.opt(builder.listOf(builder.str('promotionIds'))),
    promotionWeekType: builder.opt(builder.senum('promotionWeekType', PromotionWeekType_1.PromotionWeekType, '')),
    themeIds: builder.opt(builder.listOf(builder.str('themeIds'))),
    states: builder.opt(builder.listOf(new PropDesc_1.PropDesc(new Parser_1.EnumParser(WindowStateEnum_1.WindowStateEnum), {
      nameKey: 'states',
      lookup: ''
    }))),
    windowWFState: builder.opt(builder.listOf(new PropDesc_1.PropDesc(new Parser_1.EnumParser(WindowStateEnum_1.WindowStateEnum), {
      nameKey: 'windowWFState',
      lookup: ''
    }))),
    excludedStates: builder.opt(builder.listOf(new PropDesc_1.PropDesc(new Parser_1.EnumParser(WindowStateEnum_1.WindowStateEnum), {
      nameKey: 'excludedStates',
      lookup: ''
    }))),
    simulationsOnly: builder.opt(builder.bool('simulationsOnly')),
    stateFlags: builder.opt(builder.listOf(builder.str('stateFlags'))),
    portfolios: builder.opt(builder.listOf(builder.str('portfolios'))),
    dummy: builder.opt(builder.bool('dummy')),
    dummyOriginId: builder.opt(builder.str('dummyOriginId')),
    storeSpecifications: builder.opt(builder.listOf(new PropDesc_1.PropDesc(new Parser_1.EnumParser(StoreSpecificationEnum_1.StoreSpecificationEnum), {
      nameKey: 'storeSpecifications',
      lookup: ''
    }))),
    promotionWFState: builder.opt(builder.listOf(new PropDesc_1.PropDesc(new Parser_1.EnumParser(PromotionStateEnum_1.PromotionStateEnum), {
      nameKey: 'promotionWFState',
      lookup: ''
    }))),
    fcApprovalRequired: builder.opt(builder.bool('fcApprovalRequired')),
    validityInterval: builder.opt(builder.obj(DateRange_1.DateRange.name, DateRange_1.DateRange.schema, function (mat) {
      return new DateRange_1.DateRange(mat.from, mat.to);
    }))
  };
}();